export default {
  cartSummaryTitle: {
    id: 'funnel_summary_title_without_details',
    defaultMessage: 'Summary',
  },
}
